import { render, staticRenderFns } from "./tab-vertical.vue?vue&type=template&id=6ecdde33&scoped=true&"
import script from "./tab-vertical.vue?vue&type=script&lang=js&"
export * from "./tab-vertical.vue?vue&type=script&lang=js&"
import style0 from "./tab-vertical.vue?vue&type=style&index=0&id=6ecdde33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecdde33",
  null
  
)

export default component.exports